import axios from 'axios';
import apiClient from './_axios';

// export const xenditClient = axios.create({
//    baseURL: process.env.VITE_API_URL,
//    headers: {
//       'Content-Type': 'application/json',
//       // Authorization: `Basic xnd_development_SeIIIqWTxyHtBKPGqJ0bMhvTUAnzWgWv0sTsoBCPYkyZ1THsJCI3L3Xax7xJwRXo`,
//       Authorization: `Basic ${process.env.VITE_XENDIT_SECRET_KEY}`,
//    },
// });

export interface StoreSubscription {
   result: {
      id: string;
      name: string;
      duration: number;
      pro: boolean;
   }[];
}

// export const createSubscription = async (
//    storeId: string,
//    subscribe: string
// ) => {
//    // const response = await apiClient.post('/subscription/createSubscription', {
//    //    storeId,
//    //    subscribe,
//    // });
//    // return response.data;
// };

export async function fetchStoreWithSubscription(): Promise<StoreSubscription> {
   const response = await apiClient.get<StoreSubscription>(
      '/subscription/stores'
   );
   return response.data;
}
